module.exports = __webpack_public_path__ + "static/media/repuestos.8d29348b.png";